import { useQuery } from 'src/shared/lib/useQuery';
import { genQueryKey } from 'src/shared/lib/query.utils';
import { QueryResult } from 'src/shared/types/util.types';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { ExtractionModel } from 'src/shared/types/extraction-model.types';

export function useExtractionModel(modelId?: string): QueryResult<ExtractionModel> {
  const { orgFetch, currentOrg } = useOrg();

  const queryKey = ['next-gen', 'models', modelId, genQueryKey(currentOrg.id)];

  return useQuery({
    queryFn: getData,
    queryKey: queryKey,
    enabled: !!modelId,
    staleTime: 0,
  });

  async function getData() {
    const res = await orgFetch<ExtractionModel>(`/api/v2/next-gen-models/extraction/${modelId}`);
    if (!res.ok) {
      throw new Error('Failed to fetch models');
    }
    const model = await res.json();

    return model;
  }
}
